import { createModel } from "hox";
import { message } from "antd";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/ScmTypes";
import { useState, useEffect } from "react";

import {
    DEFAULT_FIRST_PAGE_NUM,
    DEFAULT_PAGE_SIZE,
} from "@/utils/constants";
import { ISaleSoSearch, ISaleSoDetail } from "./saleSoTypes"
import useGlobalModel from "@/model/globalModel";
import { sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import { saleSoService } from "./saleSoService"
import { transPgToPagination, formatNum } from "@/utils/utils";
import { convertRes2Blob } from "@/utils/exportFile";
export interface IDescTotal {
    totalNum: number,
    totalAmount: number,
    discountTotalAmount: number,
    receivedAmount: number,
    latestPurPrice: number,
    receivableAmount: number,
    grossProfit: number
}

export const useSaleSoModel = createModel(function () {
    const { shopAndOrg, setLoadingInfo } = useGlobalModel(({ shopAndOrg }) => [shopAndOrg]);;
    const [print, setPrint] = useState<boolean>(false);
    //切换站点清除缓存
    useEffect(() => {
        // setSelectedRowKeys([]);
        reset();
    }, [shopAndOrg.shopCode])
    const initSearchParam: ISaleSoSearch = {};
    const initDataSource: ISaleSoDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initDesc = {
        totalNum: 0,
        totalAmount: 0,
        discountTotalAmount: 0,
        receivedAmount: 0,
        latestPurPrice: 0,
        receivableAmount: 0,
        grossProfit: 0
    }
    //查询条件
    const [searchParam, setSearchParam] = useState<ISaleSoSearch>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<ISaleSoDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //表格选中的值
    const [selectedRow, setSelectedRow] = useState<ISaleSoDetail>({});
    //列表数据源分页参数
    const [confirmModal, setConfirmModal] = useState<boolean>(false);    //库房确认弹框

    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [descTotal, setDescTotal] = useState<IDescTotal>(initDesc);
    //选中的数据统计展示的数据
    const [rowsDescTotal, setRowsDescTotal] = useState<IDescTotal>(initDesc);
    const [descRows, setDescRows] = useState<ISaleSoDetail[]>([]);

    useEffect(() => {
        let newRowsDescTotal = initDesc
        descRows.forEach((item) => {
            let { totalNum, totalAmount, discountTotalAmount, receivedAmount, receivableAmount, totalCost, grossProfit } = item
            newRowsDescTotal.totalNum += (totalNum as number)
            newRowsDescTotal.totalAmount += +formatNum(totalAmount)
            newRowsDescTotal.discountTotalAmount += +formatNum(discountTotalAmount)
            newRowsDescTotal.receivedAmount += +formatNum(receivedAmount)
            newRowsDescTotal.latestPurPrice += +formatNum(totalCost)
            newRowsDescTotal.receivableAmount += +formatNum(receivableAmount)
            newRowsDescTotal.grossProfit += +formatNum(grossProfit)
        })
        setRowsDescTotal(newRowsDescTotal)
    }, [descRows])

    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedRow(selectedData as ISaleSoDetail)
    }, [selectedRowKeys, dataSource])

    const [bingingModal, setBindingModal] = useState<boolean>(false);   //绑定弹框
    const [bingingDetailModal, setBindingDetailModal] = useState<boolean>(false);   //绑定明细弹框
    const [cancelSettleModal, setCancelSettleModal] = useState<boolean>(false);   //取消结算明细弹框
    const [dispatchingModal, setDispatchingModal] = useState<boolean>(false);    //派工弹框

    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: ISaleSoSearch) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
        setSelectedRowKeys([])
        setSelectedRow({})
    }
    const reset = () => {
        setSearchParam(initSearchParam);
        setSelectedRowKeys([])
        setSelectedRow({})
    }
    const loadData = async (page?: ISearchPage, searchValue: ISaleSoSearch = searchParam) => {
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId
        };
        const searchParams = {
            ...searchValue,
            ...shopParam,
            ...sourceAppOrBranch,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await saleSoService.page(searchParams);
        const { records, ...pg } = retData
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        loadTotal(searchParams);

    }
    const loadTotal = async (searchParams: any) => {
        let { retData: statistics } = await saleSoService.total(searchParams);
        setDescTotal(statistics)
    }
    const invalidate = async (cancelReason: string) => {
        let { id, saleCode } = selectedRow
        let { retData } = await saleSoService.invalidate({ id, saleCode, cancelReason });
        if (retData) {
            loadData()
            message.success("作废成功")
        }
    }
    const exportSaleSo = async (searchValue: ISaleSoSearch = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" })
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId
        };
        const searchParams = {
            ...searchValue,
            ...shopParam,
            id: selectedRowKeys.join(),
        }
        try {
            let result = await saleSoService.export(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result)
        } catch {
            setLoadingInfo({ loadingVisible: false, txt: "" });
        }

    }
    const detailsExport = async (searchValue: ISaleSoSearch = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" })
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId
        };
        const searchParams = {
            ...searchValue,
            ...shopParam,
            settlementEndTime: searchParam.settlementEndTime ? searchParam.settlementEndTime.replace(/T/g, " ") : searchParam.settlementEndTime,
            settlementStartTime: searchParam.settlementStartTime ? searchParam.settlementStartTime.replace(/T/g, " ") : searchParam.settlementStartTime,
            id: selectedRowKeys.join(),
            saleCode: selectedRowKeys.length > 0 ? dataSource.filter(el => selectedRowKeys.indexOf(el.id as string) != -1).map(itemMap => itemMap.saleCode).join() : searchValue.saleCode
        }
        try {
            let result = await saleSoService.detailsExport(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result)
        } catch (error) {
            setLoadingInfo({ loadingVisible: false, txt: "" });
        }

    }
    const [settleScaniaPrint, setSettleScaniaPrint] = useState<boolean>(false);

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        initPgCfg,
        bingingModal,
        bingingDetailModal,
        cancelSettleModal,
        dispatchingModal,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setBindingModal,
        setBindingDetailModal,
        setCancelSettleModal,
        setDispatchingModal,
        descTotal, setDescTotal,
        selectedRow, setSelectedRow,
        invalidate,
        exportSaleSo,
        print, setPrint,
        detailsExport,
        rowsDescTotal, setRowsDescTotal,
        descRows, setDescRows,
        settleScaniaPrint, setSettleScaniaPrint,
        reset,
        confirmModal, setConfirmModal
    }
});